import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

function commonFunHOC(WrappedComponent) {
    class funHOC extends React.Component {};
    hoistNonReactStatics(funHOC, WrappedComponent);
    return funHOC;
}
export default commonFunHOC;